import React from 'react';
import PropTypes from 'prop-types'; /* eslint-disable-line no-unused-vars */

import NumberFormat from 'react-number-format';

const NumberFormatCustom = props => {
  const {
    inputRef,
    onChange,
    decimalSeparator,
    decimalScale,
    prefix,
    allowNegative,
    displayType,
    onKeyDown,
    minValue,
    maxValue,
    forwardedRef,
    ...other
  } = props;

  const isAllowed = values => {
    const { floatValue } = values;
    return !floatValue || (floatValue >= minValue && floatValue <= maxValue);
  };

  return (
    <NumberFormat
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.floatValue,
          },
        });
      }}
      isAllowed={values => isAllowed(values)}
      decimalSeparator={decimalSeparator}
      prefix={prefix}
      allowNegative={allowNegative}
      decimalScale={decimalScale}
      displayType={displayType}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func, // eslint-disable-line react/require-default-props
  onChange: PropTypes.func, // eslint-disable-line react/require-default-props
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  allowNegative: PropTypes.bool,
  displayType: PropTypes.string,
  onKeyDown: PropTypes.func,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  forwardedRef: PropTypes.string,
};

NumberFormatCustom.defaultProps = {
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: false,
  prefix: '',
  suffix: '%',
  allowNegative: false,
  minValue: 0,
  maxValue: 100,
  displayType: 'type',
  forwardedRef: '',
  onKeyDown: e => {
    const { key, target } = e;
    const { selectionStart, value } = target;
    if (key === '.') {
      e.preventDefault();
      target.value = `${value.substr(0, selectionStart)},${value.substr(selectionStart, value.length)}`;
    }
  },
};

export default NumberFormatCustom;
